import { render, staticRenderFns } from "./BulkItemCreateOrUpdate.vue?vue&type=template&id=74431de2&scoped=true&"
import script from "./BulkItemCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkItemCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BulkItemCreateOrUpdate.vue?vue&type=style&index=0&id=74431de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74431de2",
  null
  
)

export default component.exports